'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslate = exports.translate = exports.I18n = undefined;

var _i18n = require('./i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _translate = require('./translate');

var _translate2 = _interopRequireDefault(_translate);

var _useTranslate = require('./useTranslate');

var _useTranslate2 = _interopRequireDefault(_useTranslate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.I18n = _i18n2.default;
exports.translate = _translate2.default;
exports.useTranslate = _useTranslate2.default;